import { render, staticRenderFns } from "./seatsToSuit.vue?vue&type=template&id=a3cc6e96&scoped=true&"
import script from "./seatsToSuit.vue?vue&type=script&lang=js&"
export * from "./seatsToSuit.vue?vue&type=script&lang=js&"
import style0 from "./seatsToSuit.vue?vue&type=style&index=0&id=a3cc6e96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cc6e96",
  null
  
)

export default component.exports